import { z } from 'zod';

const placeholder = /replace-with|example|your-/i;

export const adminEnvironmentSchema = z.object({
  VITE_APP_ENV: z.enum(['local', 'staging', 'production']).default('local'),
  VITE_SUPABASE_URL: z
    .url()
    .refine((value) => !placeholder.test(value), 'Placeholder URL is not allowed'),
  VITE_SUPABASE_ANON_KEY: z
    .string()
    .min(20)
    .refine((value) => !placeholder.test(value), 'Placeholder key is not allowed'),
});

export type AdminEnvironment = z.infer<typeof adminEnvironmentSchema>;

export function parseAdminEnvironment(values: Record<string, unknown>): AdminEnvironment {
  return adminEnvironmentSchema.parse(values);
}

export function inspectAdminEnvironment(values: Record<string, unknown>): {
  configured: boolean;
  message: string;
  identity: 'LOCAL' | 'STAGING' | 'PRODUCTION';
} {
  const result = adminEnvironmentSchema.safeParse(values);
  return result.success
    ? {
        configured: true,
        message: `${result.data.VITE_APP_ENV} backend configuration detected.`,
        identity: result.data.VITE_APP_ENV.toUpperCase() as 'LOCAL' | 'STAGING' | 'PRODUCTION',
      }
    : {
        configured: false,
        message: 'Backend configuration required. Copy .env.example and add local Supabase values.',
        identity:
          values.VITE_APP_ENV === 'staging'
            ? 'STAGING'
            : values.VITE_APP_ENV === 'production'
              ? 'PRODUCTION'
              : 'LOCAL',
      };
}
